/**
 * This Helper is a collection of helper functions for the $http service and handling our
 * Backend responses and needs
 */
export class httpHandler {
    /**
     * Resolves or rejects promise due to the returned response.
     *
     * @param deferred object which represents a task which will finish in the future.
     * @param response The $http response object
     * @param success Callback gets called for successful responses. Returned value gets resolved in Promise
     * @param failure Callback gets called for failed responses. Returned value gets rejected in Promise
     */
    static handleResponse(
        deferred: any,
        response: object,
        success?: (json: object) => any,
        failure?: (error: object) => any
    ): void {
        const json = response["data"];
        if (json["success"]) {
            deferred.resolve(success ? success(json) : json["data"]);
        } else {
            deferred.reject(failure ? failure(json) : json);
        }
    }
}
